module.exports = __webpack_public_path__ + "img/bottom-back.19146e3f.jpg";